import React, { useState, useEffect, useMemo } from "react";
import moment from "moment";
import CourseNav from "./course_nav_container";
import { BarLoader } from "react-spinners";
import BookingPage from "./booking_page_container";
import CreateTask from "./tasks_container";

import "./frontdesk.css";

export default function Frontdesk(props) {
  const {
    fetchAppointments,
    fetchTasks,
    tasks,
    postTask,
    newTask,
    deleteTask,
    deletedTask,
    currentUser,
    dailyAppointments,
    fetchAppointments2,
    monthlyAppointments,
    fetchClients,
    clients,
    fetchClientAppts,
    clientAppts,
  } = props;

  const [result, setResult] = useState(null);
  const [dateObject, setDateObject] = useState(moment());
  const [year, setYear] = useState(null);
  const [month, setMonth] = useState(null);
  const [currentDay, setCurrentDay] = useState(null);
  const [selectedFullDate, setSelectedFullDate] = useState(null);
  const [monthDigit, setMonthDigit] = useState(null);
  const [minMaxDate, setMinMaxDate] = useState(null);
  const [writtenDate, setWrittenDate] = useState(null);
  const [writtenMonth, setWrittenMonth] = useState(null);
  const [yearsOpen, setYearsOpen] = useState(false);
  const [monthsOpen, setMonthsOpen] = useState(false);
  const [datesList, setDatesList] = useState(null);
  const [bookingPage, setBookingPage] = useState(false);
  const [chosenClient, setChosenClient] = useState(null);
  const [taskPage, setTaskPage] = useState(false);

  const jsDate = new Date();

  const months = useMemo(
    () => ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    []
  );

  const monthsFull = useMemo(
    () => [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    []
  );

  const artists = useMemo(
    () => ["Nikky", "Sean", "Karlee", "Kyla", "Karla", "Cheyenne", "STUDENTS"],
    []
  );

  /* ========= INITIALIZE TODAY ========= */

  useEffect(() => {
    const today = moment();
    const mIndex = today.month();
    const shortMonth = months[mIndex];

    setMonth(shortMonth);
    setYear(String(today.year()));
    setCurrentDay(today.date());
    setSelectedFullDate(today.format("llll"));
    setDateObject(today);
  }, [months]);

  const goToToday = () => {
  const today = moment();
  const mIndex = today.month();
  const shortMonth = months[mIndex];
  const y = String(today.year());
  const md = String(mIndex + 1).padStart(2, "0");
  const d = today.date();
  const minMax = `${y}-${md}-${String(d).padStart(2, "0")}`;

  setMonthsOpen(false);
  setYearsOpen(false);

  // set the visible date state (even if same)
  setMonth(shortMonth);
  setYear(y);
  setCurrentDay(d);
  setDateObject(today);
  setSelectedFullDate(today.format("llll"));

  // IMPORTANT: set minMaxDate so fetch trigger always has the right value
  setMinMaxDate(minMax);

  // clear lists for clean UI
  setResult(null);
  setDatesList(null);

  // IMPORTANT: force the fetch immediately (so refresh works even if date unchanged)
  fetchAppointments(null, minMax, minMax);
  fetchAppointments2(null, `${y}-${md}-01`, `${y}-${md}-31`);
};


  /* ========= TASKS ========= */

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchTasks();
  }, [fetchTasks]);

  useEffect(() => {
    if (newTask) fetchTasks();
  }, [newTask, fetchTasks]);

  useEffect(() => {
    if (deletedTask) fetchTasks();
  }, [deletedTask, fetchTasks]);

  function removeTask(task_id) {
    deleteTask(task_id);
    fetchTasks();
  }

  /* ========= PANEL TOGGLES ========= */

  function openTaskPage() {
    setTaskPage((prev) => !prev);
  }

  function openBookingPage(client) {
    setBookingPage(true);
    setChosenClient(client);
  }

  /* ========= WEEKDAYS ========= */

  const weekdayshort = moment.weekdaysShort();
  const weekdayshortname = weekdayshort.map((day) => (
    <th key={day} className="week-day">
      {day}
    </th>
  ));

  function getAppointments() {
    if (!minMaxDate) return;
    fetchAppointments(null, minMaxDate, minMaxDate);
  }

  function getAppointments2() {
    if (!year || !monthDigit) return;
    fetchAppointments2(null, `${year}-${monthDigit}-01`, `${year}-${monthDigit}-31`);
  }

  /* ========= DATE DERIVATION ========= */

  useEffect(() => {
    if (month) {
      const md = months.indexOf(month) + 1;
      setMonthDigit(String(md).padStart(2, "0"));
    }
  }, [month, months]);

  useEffect(() => {
    if (currentDay && monthDigit && year) {
      setMinMaxDate(`${year}-${monthDigit}-${String(currentDay).padStart(2, "0")}`);
    }
  }, [currentDay, monthDigit, year]);

  useEffect(() => {
    if (minMaxDate) {
      getAppointments();
      getAppointments2();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [minMaxDate]);

  useEffect(() => {
    if (year && month && currentDay) {
      const mIndex = months.indexOf(month);
      const updated = moment().set({
        date: currentDay,
        month: mIndex,
        year: Number(year),
      });
      setDateObject(updated);
      setSelectedFullDate(updated.format("llll"));
      setWrittenDate(`${monthsFull[mIndex]} ${year}`);
      setWrittenMonth(monthsFull[mIndex]);
    }
  }, [year, month, currentDay, months, monthsFull]);

  /* ========= APPOINTMENTS COLLECTIONS ========= */

  useEffect(() => {
    if (dailyAppointments) setResult([...dailyAppointments]);
  }, [dailyAppointments]);

  useEffect(() => {
    if (monthlyAppointments && month) {
      const list = [];
      monthlyAppointments.forEach((appointment) => {
        if (appointment?.date?.split(" ")?.[0]?.includes(month)) {
          list.push(parseInt(appointment.date.split(" ")[1], 10));
        }
      });
      setDatesList(list);
    }
  }, [monthlyAppointments, month]);

  /* ========= YEAR / MONTH PICKERS ========= */

  function setSelectedYear(data) {
    if (year !== data) {
      setYear(data);
      setResult(null);
      setDatesList(null);
    }
    setYearsOpen(false);
    setMonthsOpen(false);
  }

  function setSelectedMonth(data) {
    const short = data.slice(0, 3);
    setMonth(short);
    setCurrentDay(1);

    setResult(null);
    setDatesList(null);

    setMonthsOpen(false);
    setYearsOpen(false);
  }

  function setSelectedDate(d) {
    setCurrentDay(d);
    setResult(null);
    setMonthsOpen(false);
    setYearsOpen(false);
  }

  function firstDayOfMonth() {
    return Number(dateObject.clone().startOf("month").format("d"));
  }

  function setMonths() {
    setMonthsOpen((prev) => !prev);
    setYearsOpen(false);
  }

  function setYears() {
    setYearsOpen((prev) => !prev);
    setMonthsOpen(false);
  }

  /* ========= TIME HELPERS + TIMELINE ========= */

  const timeToMoment = (t) =>
    moment(String(t).trim(), ["h:mm A", "hh:mm A", "h:mmA", "hh:mmA", "h:mma", "hh:mma"], true);

  const DAY_START = useMemo(() => moment().hour(10).minute(0).second(0), []);
  const DAY_END = useMemo(() => moment().hour(20).minute(0).second(0), []); // show until 8pm

  // 30 minutes = 48px
  const MINUTES_PER_PIXEL = 0.625; // px = minutes / 0.625
  const pixelsFromMinutes = (mins) => Math.round(mins / MINUTES_PER_PIXEL);

  const minutesFromStart = (timeStr) => {
    const m = timeToMoment(timeStr);
    if (!m.isValid()) return 0;
    const start = m.clone().hour(10).minute(0).second(0);
    return Math.max(0, m.diff(start, "minutes"));
  };

  const durationMinutes = (startStr, endStr) => {
    const s = timeToMoment(startStr);
    const e = timeToMoment(endStr);
    if (!s.isValid() || !e.isValid()) return 60;
    const diff = e.diff(s, "minutes");
    return Math.max(30, diff || 60);
  };

  // small gap so back-to-back looks separated
  const OVERLAP_GAP_MINUTES = 2;

  // true collision nudge (px)
  const COLLISION_GAP_PX = 10;

  const timeLabels = useMemo(() => {
    const labels = [];
    const start = DAY_START.clone();
    const end = DAY_END.clone();
    let cur = start.clone();

    while (cur.isSameOrBefore(end)) {
      const mins = cur.diff(start, "minutes");
      labels.push({
        key: cur.format("HH:mm"),
        label: cur.format("h:mm A"),
        top: pixelsFromMinutes(mins),
      });
      cur = cur.add(30, "minutes");
    }
    return labels;
  }, [DAY_START, DAY_END]);

  const TIMELINE_HEIGHT_PX = useMemo(() => {
    const last = timeLabels[timeLabels.length - 1];
    return (last?.top || 1200) + 90;
  }, [timeLabels]);

  /* ========= CALENDAR GRID ========= */

  const blanks = [];
  for (let i = 0; i < firstDayOfMonth(); i++) {
    blanks.push(
      <td key={`blank-${i}`} className="calendar-day empty">
        {""}
      </td>
    );
  }

  const daysInMonth = [];
  for (let d = 1; d <= dateObject.daysInMonth(); d++) {
    const isSelected = d === currentDay ? "today" : "";
    const booked = datesList && datesList.includes(d) ? "dot" : "nodot";

    daysInMonth.push(
      <td key={d} onClick={() => setSelectedDate(d)} className={`calendar-day ${isSelected} ${booked}`}>
        {d}
      </td>
    );
  }

  const totalSlots = [...blanks, ...daysInMonth];
  const calRows = [];
  let cells = [];

  totalSlots.forEach((cell, i) => {
    if (i % 7 !== 0) cells.push(cell);
    else {
      calRows.push(cells);
      cells = [cell];
    }
    if (i === totalSlots.length - 1) calRows.push(cells);
  });

  const calendar = calRows.map((row, i) => <tr key={`row-${i}`}>{row}</tr>);

  const allmonths = moment.months();

  function MonthList() {
    return (
      <div className="abs-list" onClick={(e) => e.stopPropagation()}>
        {allmonths.map((m) => (
          <button
            type="button"
            key={m}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedMonth(m);
            }}
            className={writtenMonth === m ? "calendar-month today" : "calendar-month"}
          >
            {m}
          </button>
        ))}
      </div>
    );
  }

  function YearList() {
    const currentYear = jsDate.getFullYear();
    const start = currentYear - 1;
    const end = currentYear + 4;

    const years = [];
    for (let y = start; y <= end; y++) years.push(String(y));

    return (
      <div className="abs-list-2" onClick={(e) => e.stopPropagation()}>
        {years.map((label) => (
          <button
            type="button"
            key={label}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedYear(label);
            }}
            className={year === label ? "calendar-month-2 today" : "calendar-month-2"}
          >
            {label}
          </button>
        ))}
      </div>
    );
  }

  /* ========= HELPERS ========= */

  const getServiceText = (appt) => {
    const candidates = [
      appt?.type,
      appt?.title,
      appt?.service,
      appt?.serviceName,
      appt?.appointmentType,
      appt?.details,
      appt?.notes,
    ].filter(Boolean);

    return candidates.join(" | ");
  };

  const computeStyleClass = (appt) => {
    const cat = String(appt?.category || "").toUpperCase();
    const tl = String(getServiceText(appt) || "").toLowerCase();

    const isBrow =
      /\bbrow\b/.test(tl) ||
      /\bbrows\b/.test(tl) ||
      /\bmicroblad/.test(tl) ||
      /\bombre\b/.test(tl) ||
      /\bpowder\b/.test(tl);

    const isLip =
      /\blip\b/.test(tl) ||
      /\blips\b/.test(tl) ||
      /\blip\s*blush\b/.test(tl) ||
      /\bblush\b/.test(tl);

    const isLash =
      /\blash\b/.test(tl) ||
      /\blashes\b/.test(tl) ||
      /\bliner\b/.test(tl) ||
      /\beyeliner\b/.test(tl);

    const isCombo =
      (isBrow && isLip) ||
      tl.includes("combo") ||
      tl.includes("&") ||
      tl.includes(" / ") ||
      tl.includes("/");

    if (cat.includes("STUDENTS")) return "students";
    if (isCombo) return "combo";
    if (tl.includes("package")) return "package";
    if (isLash) return "lashes";
    if (isLip) return "lips";
    if (isBrow) return "brows";
    return "other";
  };

  const formatName = (first, last) => {
    const a = (first || "").trim();
    const b = (last || "").trim();
    return `${a} ${b}`.trim().toUpperCase();
  };

  const clampMoney = (v) => (Number.isFinite(v) ? v : 0);

  /* ========= RENDER ========= */

  return (
    <div className="fade-in front-desk">
      <CourseNav
        currentUser={currentUser}
        fetchClients={fetchClients}
        clients={clients}
        fetchClientAppts={fetchClientAppts}
        clientAppts={clientAppts}
      />

      {/* LEFT */}
      <div className="left-half">
        {!result && (
          <div className="full-blur">
            <BarLoader className="ring" color="#fff" size={30} />
          </div>
        )}

        <div className="fd-left-panel">
          <div className="fd-date-header">
     

            <div className="fd-picker-row">
              {year && writtenMonth && (
                <>
                  {/* MONTH PICKER */}
                  <div className={`fd-picker ${monthsOpen ? "open" : ""} ${yearsOpen ? "hidden-by-other" : ""}`}>
                    <button
                      type="button"
                      className="picker-display"
                      onClick={(e) => {
                        e.stopPropagation();
                        setMonths();
                      }}
                    >
                      <span>{writtenMonth}</span>
                      <i className={`fas fa-sort-down ${monthsOpen ? "rot" : ""}`} />
                    </button>
                    {monthsOpen ? <MonthList /> : null}
                  </div>

                  {/* YEAR PICKER (hidden when month open) */}
                  {!monthsOpen && (
                    <div className={`fd-picker ${yearsOpen ? "open" : ""}`}>
                      <button
                        type="button"
                        className="picker-display"
                        onClick={(e) => {
                          e.stopPropagation();
                          setYears();
                        }}
                      >
                        <span>{year}</span>
                        <i className={`fas fa-sort-down ${yearsOpen ? "rot" : ""}`} />
                      </button>
                      {yearsOpen ? <YearList /> : null}
                    </div>
                  )}
                </>
              )}
            </div>
          </div>

          <div className="fd-calendar-wrapper">
            <table className="calendar-table wht">
              <thead>
                <tr>{weekdayshortname}</tr>
              </thead>
              <tbody>{calendar}</tbody>
            </table>
          </div>

          <div className="task-list">
            <div className="scheduled-appt-title wht fxd">
              Task List
              <span>
                <button onClick={openTaskPage} className="add-btn" type="button">
                  <div className="inner-add-btn">+</div>
                </button>
              </span>
            </div>

            <div className="inner-task-list">
              {tasks &&
                Object.keys(tasks)
                  .reverse()
                  .map((key) => {
                    const t = tasks[key];
                    return (
                      <div key={t._id} className="task-box">
                        <div className="submitted-by">Task by {t.submittedBy}</div>
                        <div className="submitted-by date">
                          {t.createdAt.split("T")[0].split("-")[1]}/{t.createdAt.split("T")[0].split("-")[2]}/
                          {t.createdAt.split("T")[0].split("-")[0]}
                        </div>

                        <div className="submitted-by-body">{t.body}</div>
                        <div className="task-btn-row">
                          <button onClick={() => removeTask(t._id)} className="task-btn" type="button">
                            <i className="fa-light fa-trash-can" />
                          </button>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </div>
        </div>
      </div>

      {/* RIGHT */}
      <div className="right-half">
        
        {/* refresh button moved here (replaces old collapse button spot) */}
   <div className="fd-right-tools">
  <div className="refresh-orbit">
    <svg viewBox="0 0 100 100" className="refresh-text-circle" aria-hidden="true">
      <defs>
    <path
  id="refreshPathFd"
  d="M50,50 m-36,0 a36,36 0 1,1 72,0 a36,36 0 1,1 -72,0"
/>

      </defs>

      <text className="refresh-text">
        <textPath href="#refreshPathFd" startOffset="50%" textAnchor="middle">
          REFRESH • DATE TODAY •
        </textPath>
      </text>
    </svg>

    <button
      type="button"
      onClick={goToToday}
      className="refresh refresh-float"
      title="Jump back to Today"
    >
      <i className="fa-sharp fa-regular fa-bullseye" />
    </button>
  </div>
</div>


        <div className="fd-right-inner">
          <div className="scheduled-appt-title moving-gradient">
            Scheduled Appointments for{" "}
            {month && currentDay && year ? `${month} ${currentDay}, ${year}` : "Selected Date"}
          </div>

          <div className="wht c fd-subtitle">To Schedule a Touch Up, Click on Your First Session Appointment</div>

          {minMaxDate && (
            <div className="inside-right-half">
              <div className="fd-day-grid">
                {/* Only show columns with appts */}
                {artists
                  .map((artistName) => {
                    const artistAppts = result?.filter((appt) => appt.calendar === artistName) || [];
                    return { artistName, artistAppts };
                  })
                  .filter((x) => x.artistAppts.length > 0)
                  .map(({ artistName, artistAppts }) => {
                    const sortedArtistAppts = artistAppts.slice().sort((a, b) => {
                      const ma = timeToMoment(a.time);
                      const mb = timeToMoment(b.time);
                      if (!ma.isValid() || !mb.isValid()) return 0;
                      return ma.valueOf() - mb.valueOf();
                    });

                    // build timeline items with heights, then nudge to prevent overlap
                    const built = sortedArtistAppts.map((appt) => {
                      const topRaw = pixelsFromMinutes(minutesFromStart(appt.time));
                      const dur = durationMinutes(appt.time, appt.endTime);
                      const height = Math.max(
                        56,
                        pixelsFromMinutes(Math.max(30, dur - OVERLAP_GAP_MINUTES)) - 6
                      );
                      return { appt, top: topRaw, height };
                    });

                    // collision resolver (nudge)
                    const nudged = [];
                    let lastBottom = -Infinity;
                    built.forEach((item) => {
                      let nextTop = item.top;
                      if (nextTop < lastBottom + COLLISION_GAP_PX) {
                        nextTop = lastBottom + COLLISION_GAP_PX;
                      }
                      const bottom = nextTop + item.height;
                      lastBottom = bottom;
                      nudged.push({ ...item, top: nextTop });
                    });

                    return (
                      <div key={artistName} className="fd-artist-column">
                        <div className="artist-col-name">{artistName}</div>

                        <div className="fd-artist-track">
                          <div className="fd-timeline-canvas" style={{ height: `${TIMELINE_HEIGHT_PX}px` }}>
                            <div className="fd-time-rail" aria-hidden="true">
                              {timeLabels.map((t) => (
                                <div key={t.key} className="fd-time-label" style={{ top: `${t.top}px` }}>
                                  {t.label}
                                </div>
                              ))}
                            </div>

                            {nudged.map(({ appt, top, height }) => {
                              const styleClass = computeStyleClass(appt);

                              const priceSold = clampMoney(parseInt(appt.priceSold || 0, 10));
                              const amountPaid = clampMoney(parseInt(appt.amountPaid || 0, 10));
                              const balance = priceSold - amountPaid;

                              return (
                                <div
                                  key={appt._id}
                                  onClick={() => openBookingPage(appt)}
                                  className={`fd-appointment-card ${styleClass}`}
                                  style={{ top: `${top}px`, height: `${height}px` }}
                                >
                                  {/* top tiny time line */}
                                  <div className="appt-time-top">
                                    {appt.time} – {appt.endTime}
                                  </div>

                                  {/* name + balance row */}
 <div className="appt-hero-row">
  <div className="appt-name">{formatName(appt.firstName, appt.lastName)}</div>
</div>

<div className="appt-body">
  {/* NEW: compact finance row under the name */}
  <div className="appt-finance-row">
    <div className="appt-finance-chip balance">
      <span className="k">DUE</span>
      <span className="v">${balance.toFixed(2)}</span>
    </div>

{balance > 0 && (
  <div className="appt-finance-chip cc">
    <span className="k">CC</span>
    <span className="v">${(balance * 1.05).toFixed(2)}</span>
  </div>
)}

  </div>




                                    <div className="appt-service">{appt.type}</div>

                                    {appt.forms &&
                                      Object.keys(appt.forms).map((fKey) => {
                                        const form = appt.forms[fKey];
                                        if (!form?.name || !form.name.includes("Medical Form")) return null;

                                        return (
                                          <div key={fKey} className="medical-form-overall">
                                            {form.values?.[0] &&
                                              !String(form.values[0].value || "")
                                                .toLowerCase()
                                                .includes("none") &&
                                              form.values[0].value}
                                            {form.values?.[1] &&
                                              !String(form.values[1].value || "")
                                                .toLowerCase()
                                                .includes("none") && (
                                                <>
                                                  {" "}
                                                  • {form.values[1].value}
                                                </>
                                              )}
                                          </div>
                                        );
                                      })}

                                    {appt.notes && <div className="today-notes">{appt.notes}</div>}

                                    <div className="appt-money">
                                      <div>
                                        Price: <span>${priceSold}.00</span>
                                      </div>
                                      <div>
                                        Paid: <span>${amountPaid}.00</span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </div>

              {result && result.length === 0 && <div className="fd-no-appts">There are no scheduled appointments.</div>}
            </div>
          )}
        </div>
      </div>

      {/* click-outside overlay for pickers */}
      {monthsOpen || yearsOpen ? (
        <div
          className="full-blur"
          onClick={() => {
            setMonthsOpen(false);
            setYearsOpen(false);
          }}
        />
      ) : null}

      {bookingPage && chosenClient && (
        <BookingPage client={chosenClient} closeTouchup={() => window.location.reload()} />
      )}

      {taskPage && <CreateTask close={openTaskPage} postTask={postTask} />}
    </div>
  );
}
